export const TEXT_NODE_SYMBOL = Symbol('TextNode');
export const ELEMENT_SYMBOL = Symbol('Element');
export const NATIVE_NODE_SYMBOL = Symbol('NativeNode');
export const VIRTUAL_NODE_SYMBOL = Symbol('VirtualNode');
export const SHADOW_ROOT_SYMBOL = Symbol('ShadowRootSymbol');
export const COMPONENT_SYMBOL = Symbol('Component');
export const isTextNode = (e) => !!e && e[TEXT_NODE_SYMBOL];
export const isElement = (e) => !!e && e[ELEMENT_SYMBOL];
export const isNativeNode = (e) => !!e && e[NATIVE_NODE_SYMBOL];
export const isVirtualNode = (e) => !!e && e[VIRTUAL_NODE_SYMBOL];
export const isShadowRoot = (e) => !!e && e[SHADOW_ROOT_SYMBOL];
export const isComponent = (e) => !!e && e[COMPONENT_SYMBOL];
//# sourceMappingURL=type_symbol.js.map